import SalesSummaryComponent from './SalesSummary';

const SalesSummary = SalesSummaryComponent;

export default SalesSummary;
